let MyValidateForm = null 
export default MyValidateForm = {

  data(){
    return{
      relationship:[
        {id:1, name:'Hermano/a'},
        {id:2, name:'Hijo/a'},
        {id:3, name:'Padre/Madre'},
        {id:4, name:'Tio/a'},
        {id:5, name:'Abuelo/a'},
        {id:6, name:'Primo/a'},
        {id:7, name:'Sobrino/a'},
        {id:8, name:'Amigo/a'},
        {id:9, name:'Esposo/a'},
        {id:10, name:'Suegra/o'},
        {id:11, name:'Cuñado/a'},
        {id:12, name:'Otro'},
      ],
    }
  },
  methods:{
    validateForm(id,idNewElement,model,validationType){
      let passForm = true
      if(validationType == 'null'){
        if (model == null || model == undefined){
          this.removeItem(idNewElement)
          passForm =  false
          this.createItem(id,idNewElement)
        }
        else{
          this.removeItem(idNewElement)
        }
      }else if(validationType == 'length'){
        if (model.length == 0){
          this.removeItem(idNewElement)
          passForm =  false
          this.createItem(id,idNewElement)
        }
        else{
          this.removeItem(idNewElement)
        }
      }else if(validationType == '0'){
        if (model == 0){
          this.removeItem(idNewElement)
          passForm =  false
          this.createItem(id,idNewElement)
        }
        else{
          this.removeItem('alertContractType')
        }
      }
      return passForm
    },
    removeItem(id){
      if(document.getElementById(id)){
        document.getElementById(id).remove()
      }
    },
    createItem(id,idNewElement){
      let div = document.getElementById(id)
      let span = document.createElement('span')
      span.innerHTML = "<br>Por favor complete este campo"
      span.id = idNewElement
      span.style = "color:red; font-family: Montserrat;"
      div.appendChild(span)
    }
  }
}